import { composeIO } from 'react-compose-io'
import { cabecalhoHistoricoIO } from './CabecalhoHistorico.IO'
import { CabecalhoHistoricoView } from './CabecalhoHistorico.View'

export const CabecalhoHistorico = composeIO(CabecalhoHistoricoView, cabecalhoHistoricoIO)
